import { QueryClientProvider } from "@tanstack/react-query";
import { createRootRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import * as v from "valibot";

import { About } from "../components/about";
import { DesktopNavigation } from "../components/desktop-navigation";
import { IndexRoute } from "../components/index-route";
import { Loader } from "../components/loader";
import { MobileNavigation } from "../components/mobile-navigation";
import { MotionProvider } from "../components/motion-provider";
import { Pane } from "../components/pane";
import { RouteHelper } from "../components/three/route-helper";
import { Tooltip } from "../components/tooltip";
import { GlobalContext } from "../lib/global-context";
import { globalQuery } from "../lib/queries";
import { queryClient } from "../lib/query";
import type { VoidComponent } from "../lib/types";

const ThreeCanvas = lazy(async () => {
	const exports = await import("../components/three/three-canvas");
	return { default: exports.ThreeCanvas };
});

const Soundscape = lazy(async () => {
	const exports = await import("../components/soundscape");
	return { default: exports.Soundscape };
});

const RouteComponent: VoidComponent = () => {
	const global = Route.useLoaderData();

	return (
		<QueryClientProvider client={queryClient}>
			<GlobalContext value={global}>
				<MotionProvider>
					<main
						className="fixed inset-0 font-sans text-xs wrap-break-word whitespace-pre-line text-foreground antialiased selection:bg-accent selection:text-surface-primary"
						spellCheck={false}
					>
						<Suspense>
							<ThreeCanvas />
						</Suspense>

						<Pane />

						<IndexRoute />

						<DesktopNavigation />
						<MobileNavigation />

						<Loader />

						<About />

						<RouteHelper />

						<Suspense>
							<Soundscape />
						</Suspense>

						<Tooltip />
					</main>
				</MotionProvider>
			</GlobalContext>
		</QueryClientProvider>
	);
};

const Route = createRootRoute({
	loader: async () => queryClient.ensureQueryData(globalQuery),
	validateSearch: v.optional(v.object({ about: v.optional(v.literal(1)) })),
	component: RouteComponent,
});

export { Route };
